import { forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";
import "./style.scss";

const Input = forwardRef(
  (
    {
      name,
      label,
      error,
      required,
      showPassword = false,
      setShowPassword = null,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`input ${error ? "input--error" : ""}`}>
        <label
          className={`input__label ${required ? "input__label--required" : ""}`}
        >
          {label}
        </label>
        <div className="input__wrapper">
          <input
            ref={ref}
            id={name}
            name={name}
            className={`input__field ${error ? "input__field--error" : ""}`}
            required={required}
            {...props}
          />
          {name?.toLowerCase().includes("password") && (
            <button
              type="button"
              className="input__eye"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <EyeOff className="input__eye--icon" size={16} />
              ) : (
                <Eye className="input__eye--icon" size={16} />
              )}
            </button>
          )}
        </div>
        {error && <span className="input__error">{error}</span>}
      </div>
    );
  }
);

export default Input;
